import {http} from '../http';

export interface Azips{
    azips : {
        trnRequestType : string;
        CUSTCIF : string;
        CUSTACC : string;
        PMTCUSTID : string;
        BENEFNAME : string;
        BENEFACC : string;
        BENEFTAXID : string;
        BENEFBANKCODE : string;
        BENEFBANKNAME : string;
        BENEFBANKTAXID : string;
        BENEFBANKCORACC : string;
        BENEFBANKSWIFT : string;
        AMOUNT : number;
        PMTDET : string;
        MAINDET: string;
        INFOTOBENEF : string;
        NOTE : string;
        CUSTACCFORCOM : string;
        COMMAMOUNT : string;
    },
    edv: {
        trnRequestType: string;
        PMTCUSTID: string;
        CUSTCIF: string;
        CUSTACC: string;
        AMOUNT: number;
        BENEFNAME: string;
        BENEFACC: string;
        BENEFTAXID: string;
        BENEFBANKCODE: string;
        BENEFBANKNAME: string;
        PMTDET: string;
        INFOTOBENEF: string;
        NOTE: string;
        CUSTACCFORCOM: string
        COMMAMOUNT: string
    }
}

export const newMoneyTransferAzips = async (request_data: Azips): Promise<Azips> => {
    const { data } = await http.post<Azips>(`moneytransfer/azips-edv`, request_data);
    return data;
};
